<template>
  <div class="">
    <VueGoodTable
      mode="remote"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-per-page-change="onPerPageChange"
      @on-search="onSearch"
      :columns="columns"
      :rows="groups"
      :totalRows="totalRecords"
      :isLoading.sync="isLoading"
      :search-options="{
        enabled: true,
        placeholder: 'Tìm kiếm',
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        rowsPerPageLabel: 'Số hàng mỗi trang',
        nextLabel: 'Trang sau',
        prevLabel: 'Trang trước',
        ofLabel: 'trong',
      }"
      styleClass="vgt-table striped bordered"
    >
      <div slot="emptystate">Danh sách nhóm của bạn đang trống</div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'status'">
          <GroupStatus :status="props.row.status" />
        </span>

        <span v-else-if="props.column.field === 'name'">
          <CommonLink :to="Paths.GROUP_DETAIL(props.row.id)">
            {{ props.row.name }}
          </CommonLink>
          <br v-if="props.row.description && props.row.description.length > 0" />
          {{ props.row.description }}
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <template slot="loadingContent">
        <span class="vgt-loading__content"> Đang tải... </span>
      </template>
    </VueGoodTable>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { GroupState, Table } from '@/constants/DoITConstant'
import { getAllGroups } from '@/services/group_management_service'
import CommonLink from '@/components/common/CommonLink.vue'
import { Paths } from '@/routes/paths.js'
import GroupEditModal from '@/components/GroupsManagement/action-modals/GroupEditModal.vue'
import FAIcon from '@/components/common/FAIcon.vue'
import GroupDeleteModal from '@/components/GroupsManagement/action-modals/GroupDeleteModal.vue'
import { Colors, Permission } from '@/constants/DoITConstant.js'
import { formatDateTime } from '@/helpers/timeHelper.js'
import GroupStatus from '@/components/common/group/GroupStatus.vue'
import { mapGetters } from 'vuex'
import { AuthenticateGetter } from '@/store/modules/AuthenticateStore.js'

export default {
  name: 'GroupList',
  components: {
    GroupStatus,
    GroupDeleteModal,
    FAIcon,
    GroupEditModal,
    CommonLink,
    VueGoodTable,
  },
  data: function () {
    return {
      totalRecords: 0,
      serverParams: {
        sortAscending: false,
        sortField: 'createTime',
        page: 0,
        size: 10,
      },
      GroupState,
      groups: [],
      interval: null,
      isLoading: true,
      Paths,
      Colors,
      Permission,
      columns: [
        {
          label: 'ID',
          field: 'id',
          width: '40px',
        },
        {
          label: 'Tên nhóm',
          field: 'name',
          filterable: true,
          width: '300px',
        },
        {
          label: 'Ngày tạo',
          field: 'createTime',
          formatFn: formatDateTime,
        },
        {
          label: 'Ngày cập nhật',
          field: 'updateTime',
          formatFn: formatDateTime,
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterable: false,
          width: '160px',
        }
      ],
      refs: {
        GROUP_EDIT_MODAL: 'GROUP_EDIT_MODAL',
        GROUP_DELETE_MODAL: 'GROUP_DELETE_MODAL',
      },
    }
  },
  async mounted() {
    this.loadItems().then()
    this.interval = setInterval(() => {
      this.loadItems()
    }, Table.RELOAD_INTERVAL)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    onSearch(params) {
      this.serverParams.searchKey = params.searchTerm
      this.loadItems()
    },

    onPageChange(params) {
      this.serverParams.page = params.currentPage - 1
      this.loadItems()
    },

    onPerPageChange(params) {
      this.serverParams.size = params.currentPerPage
      this.loadItems()
    },

    onSortChange(params) {
      this.serverParams.sortAscending = params[0].type === 'asc'
      this.serverParams.sortField = params[0].field
      this.serverParams.page = 0
      this.loadItems()
    },
    async loadItems() {
      this.isLoading = true
      let responseAllGroups = await getAllGroups(this.serverParams)
      this.groups = responseAllGroups.data
      this.totalRecords = responseAllGroups.meta.total
      this.isLoading = false
    },
  },
  computed: {
    ...mapGetters({
      groupPermissions: AuthenticateGetter.GROUP_PERMISSIONS,
    }),
  },
}
</script>

<style scoped>
.action-col {
  width: 100px;
}

.th-class {
}

.icn {
  cursor: pointer;
}
</style>
